export const GET_PROFESSIONS = "getProfessions";
export const GET_PROFESSIONS_PENDING = "getProfessions/pending";
export const GET_PROFESSIONS_REJECTED = "getProfessions/rejected";
export const GET_PROFESSIONS_FULFILLED = "getProfessions/fulfilled";
